import { Dispatch } from 'redux';
import { RootAction } from 'store/state';
import { PromotionPlanInfo } from 'store/sagas/apiService/types';
import { initiatePayment, redeemPromotionPlanGrant } from 'store/state/app/actions';
import { getRedirectPaymentResultUrl } from 'components/private-bulletin-promotion/helpers';
import { INITIATE_SOURCE } from 'components/private-bulletin-promotion/types';

export function handlePromotionPlanSelect(
  dispatch: Dispatch<RootAction>,
  plan: PromotionPlanInfo,
  userKey: string,
  initiateSource: INITIATE_SOURCE,
  closeModal: (() => void) | null,
  bulletinId: string
) {
  if (plan.isUserEligibleForGrant) {
    dispatch(redeemPromotionPlanGrant({ planId: plan.id }));
  }
  else if (plan.price > 0) {
    dispatch(initiatePayment({
      productId: plan.id,
      redirectUrl: getRedirectPaymentResultUrl(userKey),
      initiateSource,
      bulletinsId: bulletinId,
    }));
  }

  if (closeModal) {
    closeModal();
  }
}
